import { render, staticRenderFns } from "./BlockAccordion.vue?vue&type=template&id=042ec2f6&scoped=true&"
import script from "./BlockAccordion.vue?vue&type=script&lang=js&"
export * from "./BlockAccordion.vue?vue&type=script&lang=js&"
import style0 from "./BlockAccordion.vue?vue&type=style&index=0&id=042ec2f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042ec2f6",
  null
  
)

export default component.exports